export default "__VITE_ASSET__C7NCfZAm__"